const COLORS = {
    WHITE: "#ffffff",
    THEME_COLOR: "#5F4BAB",
    SHADOW_COLOR: "#D7CCFF",
    SUCCESS: "#198754",
    PRIMARY: "#0C3450"
};

export default COLORS;
